// start:ng42.barrel
export * from './cancel-res-button.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/cancel-res-button/index.ts